import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-permits-report',
    templateUrl: './permits-report.component.html',
    styleUrls: ['./permits-report.component.css'],
    standalone: false
})
export class PermitsReportComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
